// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation_App__Qe-L4 {
    align-self: center;
    height: max-content;
    border: 1.5px solid rgb(51, 116, 255);
    border-radius: 12px;
    margin: 10px;
    background-color: white;

    >div {
        width: 100%;
        text-align: center;
        padding-top: 10px;
        font-size: 18px;
        color: rgb(61, 61, 172);
    }
}`, "",{"version":3,"sources":["webpack://./src/widgets/navigation/ui/navigation.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;;IAEvB;QACI,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,uBAAuB;IAC3B;AACJ","sourcesContent":[".App {\n    align-self: center;\n    height: max-content;\n    border: 1.5px solid rgb(51, 116, 255);\n    border-radius: 12px;\n    margin: 10px;\n    background-color: white;\n\n    >div {\n        width: 100%;\n        text-align: center;\n        padding-top: 10px;\n        font-size: 18px;\n        color: rgb(61, 61, 172);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `navigation_App__Qe-L4`
};
export default ___CSS_LOADER_EXPORT___;
